import { useEffect, useState } from "react";
import { Cookie } from "lucide-react";
import { getConsent, setConsent } from "@/lib/analytics";
import { Button } from "@/components/ui/button";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show banner only if the user has never made a choice
    if (!getConsent()) {
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  if (!visible) return null;

  const accept = () => { setConsent("granted"); setVisible(false); };
  const decline = () => { setConsent("denied"); setVisible(false); };

  return (
    <div
      data-testid="cookie-consent-banner"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-[200] glass rounded-2xl p-5 shadow-[0_20px_60px_-20px_rgba(0,0,0,0.6)]"
      role="dialog"
      aria-live="polite"
    >
      <div className="flex items-start gap-3">
        <Cookie className="h-5 w-5 text-gold mt-0.5 shrink-0" />
        <div className="flex-1">
          <div className="font-display text-lg text-white">A note on cookies</div>
          <p className="mt-1 text-white/70 text-sm leading-relaxed">
            IOCRI uses privacy-respecting analytics (Google Analytics 4) to understand which research and awareness content is most useful. No personal data is sold or shared.
          </p>
          <div className="mt-4 flex flex-wrap gap-2">
            <Button
              onClick={accept}
              data-testid="consent-accept"
              className="rounded-full bg-gold text-black hover:bg-gold-light h-9 px-4 text-xs font-mono tracking-widest"
            >
              ACCEPT
            </Button>
            <Button
              onClick={decline}
              data-testid="consent-decline"
              variant="outline"
              className="rounded-full border-white/20 hover:bg-white/5 text-white bg-transparent h-9 px-4 text-xs font-mono tracking-widest"
            >
              DECLINE
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
